import Instance from '../../../utils/Axios';

const GetObrasValidacao = () => async (dispatch) => {
  await Instance()
    .get(`/obras/validacao/obrasDropdown`)
    .then(({ data }) => {
      dispatch({ type: 'GET_OBRAS_VALIDACAO', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetObrasValidacao;
